import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteTrackingPage = {
  name: "deleteTrackingPage" as const,
  input: z.object({ id: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
